import React from 'react';
import styled, { css } from 'styled-components';
import InputAdornment from '@material-ui/core/InputAdornment';
import { StyledTextFieldProps, TextField } from '../TextField';
import { Search } from '../Icons/Search';

export type SearchTextFieldProps = StyledTextFieldProps;

const StyledTextField = styled(TextField)<SearchTextFieldProps>`
  && {
    ${({ theme }) => css`
      background-color: ${theme.palette.greyWhite.main};
      border-radius: ${theme.sizes.xxsmall};
      padding-left: ${theme.sizes.xsmall};

      input {
        height: ${theme.sizes.large};
      }
    `}
  }
`;

export const SearchField: React.FunctionComponent<SearchTextFieldProps> = (props) => (
  <StyledTextField
    {...props}
    variant="standard"
    InputProps={{
      disableUnderline: true,
      startAdornment: (
        <InputAdornment position="start">
          <Search color="greyLight" />
        </InputAdornment>
      ),
    }}
  />
);
